import { render, staticRenderFns } from "./TablaPreciosTodosLosTipos.vue?vue&type=template&id=6917c529"
import script from "./TablaPreciosTodosLosTipos.vue?vue&type=script&lang=js"
export * from "./TablaPreciosTodosLosTipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports